import VerificationStages from '../support/verifier/VerifierStage';
import { sleep } from '@/assets/utils';
import { submitStat } from '@/api/stats';

import {v4 as uuidv4} from 'uuid';

const state = {
  files: null,
  sessionUID: null,
  stage: VerificationStages.CHOOSE,
  verificationErrored: false,
  errorReason: ''
};

const mutations = {
  INIT_STATE: (state) => {
    state.files = null;
    state.sessionUID = null;
    state.stage = VerificationStages.CHOOSE;
    state.verificationErrored = false;
    state.errorReason = '';
  },
  SET_FILES: (state, files) => {
    state.files = files;
  },
  SET_SESSION_UUID: (state, uuid) => {
    state.sessionUID = uuid;
  },
  SET_STAGE: (state, stage) => {
    state.stage = { ...stage };
  },
  SET_VERIFICATION_ERROR: (state, payload) => {
    state.verificationErrored = payload.error;
    state.errorReason = payload.error ? payload.reason : '';
  },
  SET_STAGE_VARS: (state, payload) => {
    state.stage = { ...state.stage, ...payload };
  },
  RESET_STAGE_VARS: (state, vars) => {
    for (let i = 0; i < vars.length; i++) {
      delete state.stage[vars[i]];
    }
    state.stage = { ...state.stage };
  }
};

const actions = {
  //load the web worker ahead of use. Helps not load the worker from network when required.
  async runDummyVerification() {
    const { hashFilesWithWorker } = require('@/store/support/verifier/LGTVerifySupport.executor');
    await hashFilesWithWorker([], () => {});
  },
  resetVerification({ commit }) {
    commit('INIT_STATE');
  },
  async hashFiles({ commit, state, dispatch }, files) {
    const startTime = Date.now();
    commit('SET_FILES', files);
    commit('SET_SESSION_UUID', uuidv4());
    commit('SET_VERIFICATION_ERROR', false);
    commit('SET_STAGE', VerificationStages.VERIFYING_PROOFS);
    const { hashFilesWithWorker } = require('@/store/support/verifier/LGTVerifySupport.executor');
    const hashedFiles = await hashFilesWithWorker(files, (progressObj) => {
      const progress = (progressObj.count / files.length);
      if (progressObj.type === 'merkle') {
        commit('SET_STAGE_VARS', { merkleProgress: progress });
      } else if (progressObj.type === 'block') {
        commit('SET_STAGE_VARS', { blockProgress: progress });
      } else if (progressObj.type === 'total') {
        commit('SET_STAGE_VARS', { totalProgress: progress });
      }
    });
     //console.log(hashedFiles);
    if (state.stage.totalProgress !== 1) {
      commit('SET_VERIFICATION_ERROR', { error: true,
        reason: 'Oops! something went wrong. Please retry, or contact us for verification.' });
      return;
    }
    const totalTime = (Date.now() - startTime)/1000;
    if(totalTime < 5) //if less than 5 seconds, sleep for 10 seconds to show intro animation of verification section.
      await sleep((5 - totalTime)*1000);

    for(let i = 0; i < hashedFiles.length; i++) {
      dispatch('statReport', hashedFiles[i]);
    }
    dispatch('generateReports', hashedFiles);
  },
  generateReports({ commit }, hashedFiles) {
    commit('SET_FILES', hashedFiles);
    const categories = {};
    for (let i = 0; i < hashedFiles.length; i++) {
      const file = hashedFiles[i];
      if (!categories[file._status]) {
        categories[file._status] = 0;
      }
      categories[file._status]++;
    }
    commit('SET_STAGE', VerificationStages.GENERATED_REPORTS);
    commit('SET_STAGE_VARS', { reports: hashedFiles, categories });
    // dispatch('tryGenerating');
  },
  statReport({ state }, file) {
    submitStat({
      docName: file.docName,
      metadata: file.metadata,
      status: file._status,
      message: file._message,
      sessionUID: state.sessionUID
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
